export const customCheckboxStyles = {
  root: {
    width: '20px',
    height: '20px',
    // RedisiginProductPage Checkbox 146:12319
    // Unchecked default = secondary; checked / hover = primary
    borderColor: '#5a6172',
    hoverBorderColor: '#1a2133',
    checkedBackground: '#1a2133',
    checkedBorderColor: '#1a2133',
    checkedHoverBackground: '#1a2133',
    checkedHoverBorderColor: '#1a2133',
    disabledBorderColor: 'rgba(26, 33, 51, 0.35)',
    disabledBackground: 'transparent',
    disabledCheckedBackground: 'rgba(26, 33, 51, 0.35)',
    disabledCheckedBorderColor: 'rgba(26, 33, 51, 0.35)',
  },
}
